import axios from 'axios';
import { BASE_API_URL } from '@env';
import { useQuery } from 'react-query';
import { useUserStore } from '~providers/userStore/zustand';
import { GetEventAttendeesResponse } from '~types/api/event';

export function useGetEventGroupingAttendees({
  event_id,
}: {
  event_id: number;
}) {
  return useQuery<GetEventAttendeesResponse | undefined, Error>(
    ['eventGroupingAttendees', event_id],
    async () => {
      if (!event_id) {
        return undefined;
      }
      const token = useUserStore.getState().token;

      const config = {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
      };

      const response = await axios.get(
        `${BASE_API_URL}users/event-grouping/${event_id}/users-in-same-group`,
        config
      );

      return response.data;
    },
    { enabled: !!event_id },
  );
}
